import { render } from "./LeistungComponent.vue?vue&type=template&id=49cec416"
import script from "./LeistungComponent.vue?vue&type=script&lang=js"
export * from "./LeistungComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__